// const date = new Date();
// let day = date.getDate();
// let month = date.getMonth() + 1;
// let year = date.getFullYear();
// function getMonthName(monthNumber) {
//   const date = new Date();
//   date.setMonth(monthNumber - 1);

//   return date.toLocaleString("en-US", { month: "long" });
// }
// let currentDate = `${day}${getMonthName(month)}, ${year}`;

export const reportsColumns = [
  { field: "ReportName", headerName: "Report Name", width: 500 },
  { field: "Description", headerName: "Description", width: 500 },
  { field: "LastSeen", headerName: "Last Seen", width: 500 },
];
export const reportsRows = [
  {
    id: 1,
    ReportName: "Pack Prep Report",
    Description: "Lorem Ornare",
    LastSeen: "24 May, 2020",
  },
  {
    id: 2,
    ReportName: "Error Report",
    Description: "Venenatis Mollis",
    LastSeen: "21 Sep, 2020",
  },
  {
    id: 3,
    ReportName: "Error Report",
    Description: "Venenatis Mollis",
    LastSeen: "21 Sep, 2020",
  },
  {
    id: 4,
    ReportName: "Pack Prep Report",
    Description: "Lorem Ornare",
    LastSeen: "24 May, 2020",
  },
  {
    id: 5,
    ReportName: "Error Report",
    Description: "Venenatis Mollis",
    LastSeen: "21 Sep, 2020",
  },
  {
    id: 6,
    ReportName: "Error Report",
    Description: "Venenatis Mollis",
    LastSeen: "21 Sep, 2020",
  },
  {
    id: 7,
    ReportName: "Pack Prep Report",
    Description: "Lorem Ornare",
    LastSeen: "24 May, 2020",
  },
  {
    id: 8,
    ReportName: "Error Report",
    Description: "Venenatis Mollis",
    LastSeen: "21 Sep, 2020",
  },
  {
    id: 9,
    ReportName: "Error Report",
    Description: "Venenatis Mollis",
    LastSeen: "21 Sep, 2020",
  },
];
